var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWebIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_33663)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2858 9.99995C19.2858 12.4627 18.3075 14.8245 16.5661 16.5659C14.8247 18.3073 12.4628 19.2857 10.0001 19.2857C7.53735 19.2857 5.17549 18.3073 3.43408 16.5659C1.69267 14.8245 0.714355 12.4627 0.714355 9.99995M19.2858 9.99995C19.2858 7.53722 18.3075 5.17537 16.5661 3.43396C14.8247 1.69255 12.4628 0.714233 10.0001 0.714233C7.53735 0.714233 5.17549 1.69255 3.43408 3.43396C1.69267 5.17537 0.714355 7.53722 0.714355 9.99995M19.2858 9.99995H0.714355",
    stroke: "#00ADEF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5716 9.99995C13.3961 13.3956 12.1454 16.6476 10.0001 19.2857C7.85488 16.6476 6.60414 13.3956 6.42871 9.99995C6.60414 6.60425 7.85488 3.35231 10.0001 0.714233C12.1454 3.35231 13.3961 6.60425 13.5716 9.99995Z",
    stroke: "#00ADEF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_33663"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebIcon);
export default __webpack_public_path__ + "static/media/webIcon.7825bd84910cbae21062d818ec4f938e.svg";
export { ForwardRef as ReactComponent };